import React from "react";
import { ArrowLeft, Move, Zap, Sparkles, Target, Clock } from "lucide-react";
import { playClick } from "../game/sound";

export default function Instructions({ onBack }) {
  return (
    <div className="screen instructions-screen" data-testid="instructions-screen">
      <div className="screen-container">
        <button
          type="button"
          className="back-btn"
          onClick={() => {
            playClick();
            onBack();
          }}
          data-testid="instructions-back-button"
        >
          <ArrowLeft size={16} /> Back
        </button>
        <h2 className="screen-title">How To Play</h2>

        <div className="instructions-grid">
          <div className="instr-card">
            <Move size={22} />
            <h3>Move</h3>
            <p>
              Use <kbd>W</kbd> <kbd>A</kbd> <kbd>S</kbd> <kbd>D</kbd> or the arrow keys to pilot
              your UFO above the town.
            </p>
          </div>
          <div className="instr-card">
            <Zap size={22} />
            <h3>Tractor Beam</h3>
            <p>
              Hold <kbd>SPACE</kbd> or the <kbd>mouse</kbd> to fire the green beam. Zombies under
              the beam will float up into your saucer.
            </p>
          </div>
          <div className="instr-card">
            <Target size={22} />
            <h3>Collect Zombies</h3>
            <p>
              Each level has a quota of zombies you must collect. Fast and glowing zombies are
              worth more — but big ones take longer to beam up.
            </p>
          </div>
          <div className="instr-card">
            <Clock size={22} />
            <h3>Beat the Timer</h3>
            <p>
              Complete the goal before the timer runs out. Run out of time and the outbreak wins.
            </p>
          </div>
          <div className="instr-card">
            <Sparkles size={22} />
            <h3>Deaded Enemy Rewards</h3>
            <p>
              Every few zombies you collect, a free 3-card power chooser appears mid-run. Pick one
              of Sky Lightning, Companion Ships, Rolling Wheel, Bouncing Ball, Super Dog, beam &
              UFO boosts, and more. Rewards are temporary — they reset every run.
            </p>
          </div>
          <div className="instr-card">
            <Zap size={22} />
            <h3>Stack Powers</h3>
            <p>
              Each power can stack up to Level 5 within a run. The chooser keeps coming back at a
              growing zombie-meter threshold, so the longer you survive, the stronger you get.
            </p>
          </div>
        </div>

        <div className="zombie-legend">
          <h3>Zombie Types</h3>
          <div className="zombie-legend-row">
            <span className="zombie-chip" style={{ background: "#7ed957" }}>Regular</span>
            <span className="zombie-chip" style={{ background: "#9be36b" }}>Fast</span>
            <span className="zombie-chip" style={{ background: "#5fb53a" }}>Big</span>
            <span className="zombie-chip glow" style={{ background: "#c2ff5d" }}>Glowing +5🪙</span>
            <span className="zombie-chip boss" style={{ background: "#3fa322" }}>Boss</span>
          </div>
        </div>
      </div>
    </div>
  );
}
